import { useState } from 'react';
import useAuthentication from "../Service/hooks/useAuthentication";
import PasskeyForm from './PasskeyForm';


export default function Login({ }) {

        const { login, tokens, error: loginError } = useAuthentication();
    const [hidePasskey, setHidePasskey] = useState(false);

    const submitLogin = (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        login && login({ email: data.get('username'), password: data.get('password') });
    }

    const hasPasskeyToken = tokens?.some(token => token && token.t === 'passkey');

    if(hasPasskeyToken && !hidePasskey) {
        return <PasskeyForm onOtherLogin={() => setHidePasskey(true)} />
    }

    return <div>
        <form onSubmit={submitLogin} className="flex flex-col gap-3">
            {loginError && <div className="bg-red-500 text-white p-2"> {loginError} </div> || null}
            <label>
                <p className="text-lg">E-mail:</p>
                <input name="username" className="w-full border border-gray-300 p-2" />
            </label>
            <label>
                <p className="text-lg">Wachtwoord:</p>
                <input name="password" type="password" className="w-full border border-gray-300 p-2" />
            </label>
            <div className="text-right">
                <a href="/password-reset" className="text-blue-500">Wachtwoord vergeten?</a>
            </div>
            <button className="w-full bg-[#3A194A] text-white p-2 font-bold">Inloggen</button>
        </form>
    </div>
}